import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const RevenueChart = ({ dashboardData, filter }) => {
  const { t } = useTranslation();
  console.log(dashboardData, "dashboardData");

  const chartOptions = useMemo(() => {
    let labelArr = [];
    let seriesArr = [];

    if (dashboardData?.length) {
      dashboardData.forEach((item) => {
        const formattedDate = new Date(item._id).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
        labelArr.push(formattedDate);
        seriesArr.push(item.totalRevenue || 0);
      });
    } else {
      labelArr = ["1 Sep 2025", "2 Sep 2025", "3 Sep 2025", "4 Sep 2025"];
      seriesArr = [1200, 1500, 1000, 1800];
    }

    return {
      series: [{ name: "Revenue", data: seriesArr }],
      options: {
        chart: {
          type: "area",
          height: 350,
          zoom: { enabled: false },
          toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        stroke: {
          curve: "smooth",
          colors: ["#1C1C1C"],
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: labelArr,
          labels: {
            rotate: -45,
            style: { fontSize: "12px" },
          },
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              if (value >= 1000) return (value / 1000).toFixed(1) + "k";
              return value;
            },
          },
        },
        tooltip: {
          y: {
            formatter: (value) => `$${value.toLocaleString()}`,
          },
        },
        title: {
          text:
            filter === "today"
              ? t("dashboard.revToday")
              : filter === "week"
                ? t("dashboard.revWeek")
                : t("dashboard.revMonth"),
          align: "left",
        },
        colors: ["#1C1C1C"],
      },
    };
  }, [dashboardData, filter]);

  return (
    <div className="cardCstm p-3 border rounded">
      {chartOptions.series[0].data.length > 0 ? (
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type="area"
          height={350}
        />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default RevenueChart;
